import ExpenseLinesView from '../ExpenseLinesView.vue'
import ExpenseLineList from '../Pages/ExpenseLineList.vue'
import ExpenseLineEditor from '../Pages/ExpenseLineEditor.vue'

const routes = [
  {
    path: '/mantenimiento/lineas-gasto',
    component: ExpenseLinesView,
    children: [
      { path: '', name: 'expense-line-list', component: ExpenseLineList },
      { path: 'crear', name: 'expense-line-create', component: ExpenseLineEditor },
      { path: ':id', name: 'expense-line-edit', component: ExpenseLineEditor },
    ],
  },
]

export default routes
